import React from "react";
import { Box, Typography, Fade } from "@mui/material";
import useStoryGreetings from "../../hooks/useStoryGreetings";

const AnimatedGreeting = ({ name }) => {
  const { visibleMessage, showGreeting, key } = useStoryGreetings(name);

  return (
    <Box
      sx={{
        bgcolor: "#FFDDD9",
        px: 1.25,
        py: 0.6,
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        maxWidth: "100%",
      }}>
      <Fade in={showGreeting} timeout={600} key={key}>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", md: "1.1rem" },
            fontWeight: 600,
            fontFamily: "Poppins",
            color: "#1A1A1A",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}>
          {visibleMessage}
        </Typography>
      </Fade>
    </Box>
  );
};

export default AnimatedGreeting;
